import React from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { ArrowRight, MapPin } from "lucide-react";
import { CTAButton } from "./CTAButton";
import { WorldMap } from "./WorldMap";
import { IMAGES } from "../data/config";

export function Hero() {
  const { t } = useTranslation();
  return (
    <section className="relative overflow-hidden grain" data-testid="hero">
      <div className="absolute inset-0">
        <img src={IMAGES.heroMap} alt="" className="w-full h-full object-cover opacity-25" />
        <div className="absolute inset-0 bg-gradient-to-b from-navy-900/80 via-navy-900/88 to-navy-900" />
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_rgba(0,85,255,0.18),_transparent_55%)]" />
      </div>

      <div className="absolute inset-0 opacity-70 hidden sm:block">
        <WorldMap className="w-full h-full" />
      </div>

      <div className="container-x relative pt-36 pb-24 md:pt-44 md:pb-32">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="max-w-3xl rtl:mr-0"
        >
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-white/15 bg-white/5 text-xs text-white/70 mb-7" data-testid="hero-badge">
            <MapPin size={13} className="text-gold" />
            {t("hero.badge")} · {t("common.pronounced")}
          </div>

          <h1 className="font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05]">
            {t("hero.titleA")} <span className="text-gradient-gold">{t("hero.titleAccent")}</span>
          </h1>

          <p className="mt-6 text-base sm:text-lg text-white/65 max-w-2xl leading-relaxed">{t("hero.subtitle")}</p>

          <div className="mt-9 flex flex-col sm:flex-row gap-4">
            <CTAButton to="/quote" variant="primary" size="lg" testId="hero-quote-cta">
              {t("common.getQuote")} <ArrowRight size={18} className="rtl:rotate-180" />
            </CTAButton>
            <CTAButton to="/plans" variant="secondary" size="lg" testId="hero-plans-cta">
              {t("common.explorePlans")}
            </CTAButton>
          </div>

          <p className="mt-10 text-xs text-white/40 font-mono tracking-wide">{t("hero.route")}</p>
        </motion.div>
      </div>
    </section>
  );
}

export default Hero;
